{
  "id": "future-pm",
  "label": "Utrikes framtids-pm",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "defaultSpanDays": 29,
  "titleFollowsSpan": true,
  "filingSection": "Utrikes",
  "planning": {
    "titlePattern": "Utrikes framtids-pm {fromDate}-{toDate} {year}",
    "slugline": "TT-uframpm"
  },
  "sources": [
    {
      "type": "event",
      "newsvalues": ["2", "3", "4", "5", "6"],
      "sections": ["Utrikes"]
    }
  ],
  "postamble": [
    "Till redaktionen: Ovanstående är en orientering om kommande kända händelser. Det innebär inget automatiskt löfte om bevakning.",
    "TT:s kalender: https://tt.se/kalender/lista/.",
    "TT Nyhetsbyrån"
  ],
  "blocks": [
    {
      "id": "events",
      "label": "Händelser",
      "preamble": [],
      "grouping": "day",
      "dayHeading": "{DayName} den {longDate}",
      "item": {
        "headline": "{time} - {headline} {publicDescription}",
        "lines": []
      },
      "eventTitleSections": []
    }
  ]
}
